import { render, staticRenderFns } from "./cartonList.vue?vue&type=template&id=2fffa326&scoped=true"
import script from "./cartonList.vue?vue&type=script&lang=js"
export * from "./cartonList.vue?vue&type=script&lang=js"
import style0 from "./cartonList.vue?vue&type=style&index=0&id=2fffa326&prod&scoped=true&lang=css"
import style1 from "./cartonList.vue?vue&type=style&index=1&id=2fffa326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffa326",
  null
  
)

export default component.exports